module.exports = __webpack_public_path__ + "elephant_ui_plane-e3f2d57c12c376e189c274cbe81af8dd.svg";